import { render, staticRenderFns } from "./ZeroBuyMain.vue?vue&type=template&id=004fd43f&scoped=true&"
import script from "./ZeroBuyMain.vue?vue&type=script&lang=js&"
export * from "./ZeroBuyMain.vue?vue&type=script&lang=js&"
import style0 from "./ZeroBuyMain.vue?vue&type=style&index=0&id=004fd43f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004fd43f",
  null
  
)

export default component.exports